module.exports = __webpack_public_path__ + "tm.252af0c63c1d4bbc8544.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tm.svg
// module chunks = styles